import React, { useEffect } from "react";
import { PatientQuoteViewModel } from "./PatientQuoteViewModel.csharp";
import { PatientQuoteCardAdditionalQuotes } from "./PatientQuoteCardAdditionalQuotes";
import ReactDOM from "react-dom";
import { v4 as uuidv4 } from "uuid";

interface PatientQuoteCardProps {
  ratingIconUrl: string;
  quoteDetails: string;
}

export const PatientQuoteCard: React.FC<
  PatientQuoteViewModel & PatientQuoteCardProps
> = ({
  quote,
  additionalQuotes,
  age,
  gender,
  linkUrl,
  linkName,
  specialization,
  doctor,
  center,
  location,
  sourceLink,
  sourceName,
  dateOfReview,
  ratingIconUrl,
  quoteDetails,
}) => {
  const additionalQuotesId = `additionalQuotes-${uuidv4()}`;
  const getLink = (linkText: string, linkUrl?: string) => {
    if (linkUrl) {
      return `<a href="${linkUrl}">${linkText}</a>`;
    }
    if (linkText) return linkText;
    return "";
  };

  const quoteHtmlString = quoteDetails
    .replace("$gendername", gender)
    .replace("$age", age.toString())
    .replace("$location", location)
    .replace("$center", center)
    .replace("$specialization", specialization.toLowerCase())
    .replace("$Specialization", capitalizeFirstLetter(specialization))
    .replace("$doctor", doctor)
    .replace("$date", dateOfReview)
    .replace("$link", getLink(linkName, linkUrl))
    .replace("$source", getLink(sourceName, sourceLink))
    .replace("$quote", quote)
    .replace(
      "$additionalQuotes",
      `<span id=\"${additionalQuotesId}\">${additionalQuotes.join(".")}</span>`
    );

  function capitalizeFirstLetter(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  useEffect(() => {
    if (quoteHtmlString.indexOf(additionalQuotesId) !== -1) {
      ReactDOM.render(
          <PatientQuoteCardAdditionalQuotes additionalQuotes={additionalQuotes} />,
          document.querySelector(`#${additionalQuotesId}`)
      );
    }
  }, []);

  return (
    <div className="card card-hover theme-inherit-light featuredDoctorCard">
      <div className="card-body d-block">
        <img
          className="medium mb-3"
          src={ratingIconUrl}
          alt=""
          style={{
            height: "3.438rem !important",
            width: "100% !important",
          }}
        />
        <div dangerouslySetInnerHTML={{ __html: quoteHtmlString }} />
      </div>
    </div>
  );
};
